import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Map,
  useMap,
  // eslint-disable-next-line
} from '@vis.gl/react-google-maps/dist/index.umd.js'
import LotLabelMarker from './components/LotLabelMarker/LotLabelMarker'
import ParkingButtonPanel from './components/ParkingButtonPanel/ParkingButtonPanel'
import StopsTwo from './components/Stops/StopsTwo'
import {
  setAdditionalFilters,
  setFilters,
  setMapInstance,
  setZoom,
  updateLatLng,
} from './redux/myMapsSlice'
// import { mapDarkStyles, mapLightStyles } from '../../utils/helpers'
import BottomSheet from '../../components/BottomSheets/BottomSheet'
import useMyMapStyles from '../../MyMapStyles'
import { TabPanel } from '../../../dashboard/DashboardComponents/TabPanel/TabPanel'
import VehicleRouteTwo from '../Vehicles/components/VehicleRoute/VehicleRouteTwo'
import VehiclesTwo from '../Vehicles/VehiclesTwo'
import { selectDarkMode } from '../../../settings/settingsSlice'
import BuildingStopsTwo from './components/BuildingStops/BuildingStopsTwo'
import MapInfoWindow from './components/MapInfoWindow/MapInfoWindow'
import PolylineFromDataset from './components/PolylineFromDataset/PolylineFromDataset'
// import BuildingPolygon from './components/PolylineFromDataset/BuildingPolygon'
import CheckIsMobile from '../../../../../utils/isMobileHook'
import {
  MOBILEPARKINGINFOWINDOW,
  ROUTE,
  ROUTES,
  SEARCH,
  VEHICLE,
} from '../../utils/constants'
import Directions from './components/Directions/Directions'
import FirebaseStops from './components/FirebaseStops/FirebaseStops'
import MapOverlayWarning from './components/MapOverlayWarning/MapOverlayWarning'
import MapVisitorWarning from './components/MapOverlayWarning/MapVisitorWarning'
import ParkingNotifications from './components/ParkingNotifications/ParkingNotifications'

const MyMap = ({ disableDefaultUI = false }) => {
  const map = useMap()
  const classes = useMyMapStyles()
  const dispatch = useDispatch()
  const {
    lat,
    lng,
    zoom,
    tabValue,
    activeLotId,
    parkingLotData,
    bottomSheet,
    showDirections,
    origin,
    destination,
    markerInfo,
    filters,
    additionalFilters,
    userParkingPermitData,
  } = useSelector((s) => s.maps)
  const { drawerIsOpen } = useSelector((state) => state.navigation)
  const darkMode = useSelector(selectDarkMode)
  const isMobile = CheckIsMobile()
  const [latitude, setLatitude] = React.useState(40.51868)
  const [longitude, setLongitude] = React.useState(-74.46147)
  const [showLotLabels, updateShowLotLabels] = React.useState(false)
  const [showParkingLots, updateShowParkingLots] = React.useState(true)
  const [showBusStops, updateShowBusStops] = React.useState(true)
  const dragging = React.useRef(false)
  // set default options for target parking population
  const { userProfile } = useSelector((s) => s.myProfile)

  React.useEffect(() => {
    if (userProfile) {
      const activeOptions = [
        (userProfile?.roles?.includes('employee') ||
          userProfile?.roles?.includes('ruEmployee') ||
          userProfile?.roles?.includes('rbhsEmployee') ||
          userProfile?.roles?.includes('ruStaff') ||
          userProfile?.roles?.includes('rbhsStaff') ||
          userProfile?.roles?.includes('staff')) &&
          'Faculty/Staff',

        (userProfile?.isRuStudent ||
          userProfile?.isRbhsStudent ||
          userProfile?.isAdmit ||
          userProfile?.isAdmitComing) &&
          'student',
      ].filter(Boolean)
      dispatch(setFilters(activeOptions))
    }
  }, [userProfile])

  const bottomSheets = [SEARCH, ROUTES, ROUTE, VEHICLE, MOBILEPARKINGINFOWINDOW]
  const isMobileWithoutBottomNav =
    bottomSheets.includes(bottomSheet?.component) && isMobile

  React.useEffect(() => {
    if (lat !== latitude && lng !== longitude) {
      setLatitude(lat)
      setLongitude(lng)
      dispatch(
        updateLatLng({
          lat,
          lng,
          zoom,
        }),
      )
      //   console.log('zoom ', zoom)
      if (zoom <= 15) {
        updateShowLotLabels(false)
      } else if (zoom >= 15) {
        updateShowLotLabels(true)
      }
    }
  }, [lat, lng, zoom])

  const handleMouseChange = (camera) => {
    setLatitude(camera.map.center.lat())
    setLongitude(camera.map.center.lng())
    if (dragging.current) {
      dispatch(
        updateLatLng({
          lat: camera.map.center.lat(),
          lng: camera.map.center.lng(),
          zoom: camera.map.zoom,
        }),
      )
    }
  }
  const getMapStyles = (customClasses) => {
    if (!drawerIsOpen) {
      if (isMobileWithoutBottomNav) {
        return customClasses.mapContainerMobilePage
      }
      if (markerInfo && Object.keys(markerInfo).length !== 0) {
        return customClasses.mapContainerDirections
      }
      return customClasses.mapContainer
    }
    return customClasses.mapContainerNavOpen
  }

  React.useEffect(() => {
    if (map) {
      dispatch(setMapInstance(map))
    }
  }, [map])
  //   console.log('filters ', filters)
  return (
    <TabPanel value={tabValue} index={0}>
      <MapInfoWindow
        dispatch={dispatch}
        isMobile={isMobile}
        parkingLotData={parkingLotData}
        filterBy={filters}
        additionalFilters={additionalFilters}
        darkMode={darkMode}
      />
      <Map
        mapId="2b3f87ff16688c1e"
        renderingType="VECTOR"
        className={getMapStyles(classes)}
        defaultCenter={{ lat: 40.50045704434057, lng: -74.44818987833548 }}
        onCenterChanged={handleMouseChange}
        defaultZoom={14}
        zoom={zoom}
        onDragstart={() => {
          dragging.current = false
        }}
        onDragend={() => {
          dragging.current = false
        }}
        onZoomChanged={(newZoom) => {
          if (newZoom?.detail?.zoom) {
            dispatch(setZoom(newZoom.detail.zoom))
          }
        }}
        gestureHandling="greedy"
        colorScheme={darkMode ? 'DARK' : 'LIGHT'}
        disableDefaultUI
        options={{
          zoomControl: true,
          zoomControlOptions: { position: 7 },
          streetViewControl: true,
          mapTypeControl: true,
          fullscreenControl: true,
          streetViewControlOptions: { position: 6 },
          disableDefaultUI,
          rotateControl: false,
          tilt: 0,
        }}
      >
        <ParkingButtonPanel
          updateShowParkingLots={updateShowParkingLots}
          updateShowLotLabels={updateShowLotLabels}
          showParkingLots={showParkingLots}
          showLotLabels={showLotLabels}
          showBusStops={showBusStops}
          updateShowBusStops={updateShowBusStops}
          isMobileWithoutBottomNav={isMobileWithoutBottomNav}
          selectedFilters={filters}
          setSelectedFilters={setFilters}
          additionalFilters={additionalFilters}
          setAdditionalFilters={setAdditionalFilters}
          dispatch={dispatch}
        />
        <PolylineFromDataset
          showParkingLots={showParkingLots}
          dispatch={dispatch}
          parkingLotData={parkingLotData}
          isMobile={isMobile}
          filterBy={filters}
          showDirectionsBoolean={showDirections}
          additionalFilters={additionalFilters}
          userParkingPermitData={userParkingPermitData}
          darkMode={darkMode}
        />
        {showLotLabels ? (
          <LotLabelMarker
            parkingLotData={parkingLotData}
            activeLotId={activeLotId}
            filterBy={filters}
            additionalFilters={additionalFilters}
            userParkingPermitData={userParkingPermitData}
            latitude={latitude}
            longitude={longitude}
            dispatch={dispatch}
            isMobile={isMobile}
            zoom={zoom}
            darkMode={darkMode}
          />
        ) : null}
        {showBusStops ? <StopsTwo map={map} /> : null}
        <FirebaseStops map={map} />
        <BuildingStopsTwo />
        <VehicleRouteTwo />
        <VehiclesTwo />
        {showDirections ? (
          <Directions map={map} origin={origin} destination={destination} />
        ) : null}
        {/* <BuildingPolygon /> */}
        <BottomSheet />
        <MapOverlayWarning map={map} />
        <MapVisitorWarning selectedFilters={filters} />
        <ParkingNotifications userProfile={userProfile} />
      </Map>
    </TabPanel>
  )
}

export default MyMap
